import dayjs from 'dayjs';
import { type i18n } from 'i18next';
import { setLocale } from 'yup';

export const setValidationLocale = ({ t }: i18n) => {
  console.log(
    'setValidationLocale',
    t('mixed.defined', 'Il campo ${path} è un campo richiesto'),
    t('mixed.default', 'Il campo ${path} non è valido'),
  );
  setLocale({
    mixed: {
      default: t('mixed.default', 'Il campo ${path} non è valido'),
      defined: t('mixed.defined', 'Il campo ${path} è un campo richiesto'),
      required: t('mixed.required', 'Il campo ${path} è un campo richiesto'),
      oneOf: t(
        'mixed.oneOf',
        'Il campo ${path} deve avere uno dei seguenti valori: ${values}',
      ),
      notNull: t(
        'mixed.notNull',
        'Il campo ${path} non può essere lasciato vuoto',
      ),
      notOneOf: t(
        'mixed.notOneOf',
        'Il campo ${path} non deve avere uno dei seguenti valori: ${values}',
      ),
      notType: ({ path, type }: { path: string; type: string }) =>
        typeToMessage(path, type, t),
    },
    string: {
      length: t(
        'string.length',
        'Il campo ${path} deve avere esattamente ${length} caratteri',
      ),
      min: t(
        'string.min',
        'Il campo ${path} deve avere almeno ${min} caratteri',
      ),
      max: t(
        'string.max',
        'Il campo ${path} deve avere al massimo ${max} caratteri',
      ),
      matches: t(
        'string.matches',
        'Il campo ${path} deve seguire il seguente pattern: "${regex}"',
      ),
      email: t('string.email', 'Il campo ${path} deve essere una email valida'),
      url: t('string.url', 'Il campo ${path} deve essere un URL valido'),
      trim: t(
        'string.trim',
        'Il campo ${path} deve essere un testo senza spazi iniziali o finali',
      ),
      lowercase: t(
        'string.lowercase',
        'Il campo ${path} deve contenere solamente caratteri minuscoli',
      ),
      uppercase: t(
        'string.uppercase',
        'Il campo ${path} deve contenere solamente caratteri maiuscoli',
      ),
    },
    number: {
      min: t(
        'number.min',
        'Il campo ${path} deve essere maggiore o uguale di ${min}',
      ),
      max: t(
        'number.max',
        'Il campo ${path} deve essere minore o uguale di ${max}',
      ),
      lessThan: t(
        'number.lessThan',
        'Il campo ${path} deve essere minore di ${less}',
      ),
      moreThan: t(
        'number.moreThan',
        'Il campo ${path} deve essere maggiore di ${more}',
      ),
      positive: t(
        'number.positive',
        'Il campo ${path} deve essere un numero positivo',
      ),
      negative: t(
        'number.negative',
        'Il campo ${path} deve essere un numero negativo',
      ),
      integer: t(
        'number.integer',
        'Il campo ${path} deve essere un numero intero',
      ),
    },
    array: {
      min: (params: any) => {
        return t(
          'array.min',
          'Il campo {{path}} deve avere almeno {{count}} elemento',
          { count: params.min, path: params.path },
        );
      },
      max: (params: any) => {
        return t(
          'array.max',
          'Il campo {{path}} deve avere al massimo {{count}} elemento',
          { count: params.max, path: params.path },
        );
      },
    },
    date: {
      min: (params: any) => {
        return `La data "${
          params.path as string
        }" deve essere successiva al ${dayjs(params.min).format('DD/MM/YYYY')}`;
      },
      max: (params: any) =>
        `La data "${params.path as string}" deve essere antecedente al ${dayjs(
          params.max,
        ).format('DD/MM/YYYY')}`,
    },
  });
};

function typeToMessage(path: string, type: string, t: i18n['t']) {
  if (type === 'number') {
    return t('notType.number', 'Il campo {{path}} deve essere un numero', {
      path,
    });
  }

  if (type === 'string') {
    return t('notType.string', 'Il campo {{path}} deve essere una stringa', {
      path,
    });
  }
  return t('notType.default', 'Il campo {{path}} non è valido', {
    path,
  });
}
